export default __webpack_public_path__ + "static/body-treatments-5093d4f36b426061748daa62b16bace0.jpg";